import { apiService } from '../../shared/services/apiService';
import { UpdateVideo, VideoCategory } from '../interface/video';

type GetVideosResponse = {
  categories: VideoCategory[];
};

type DeleteVideoResponse = {
  status: string;
};

export const videosServices = {
  async getAllVideos() {
    const resp = await apiService.get<GetVideosResponse>(`/api/devices/videos`);

    return resp.data;
  },

  async getVideosBySuper() {
    const resp = await apiService.get<GetVideosResponse>('api/coach/videos');

    return resp.data;
  },

  async updateVideos(videos: { videos: UpdateVideo[] }) {
    const resp = await apiService.put<GetVideosResponse>('api/super/videos/save', videos);

    return resp.data;
  },

  async deleteVideoById(id: number) {
    const resp = await apiService.delete<DeleteVideoResponse>(`api/super/video/${id}`);

    return resp.data;
  },
};
